import React from 'react';
import PropTypes from 'prop-types';
import TranslationProvider from '../../../../providers/TranslationProvider';

const AccountRemoveError = ({ onAbort, isDueToReservation }) => (
  <>
    <div className="AccountModal__body">
      <TranslationProvider translationKey="remove_card_error_title">
        <div id="account_modal_title" className="AccountModal_title">Unable to Remove Card</div>
      </TranslationProvider>
      {!isDueToReservation && <div id="account_modal_subtitle" className="AccountModal_subtitle" />}
      {isDueToReservation && (
        <TranslationProvider translationKey="remove_card_reservation_error_subtitle">
          <div id="account_modal_subtitle" className="subtitle">This card is required for a future reservation.</div>
        </TranslationProvider>
      )}
    </div>
    <div className="AccountModal__buttons">
      <button
        type="button"
        className="back"
        onClick={onAbort}
      >
        <TranslationProvider translationKey="ok">
          <span>OK</span>
        </TranslationProvider>
      </button>
    </div>
  </>
);

AccountRemoveError.propTypes = {
  onAbort: PropTypes.func.isRequired,
  isDueToReservation: PropTypes.bool.isRequired,
};

export default AccountRemoveError;
